<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle> <!--cdkDragHandle-->
	<div style="width: 100%;">
		<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times"
				style="cursor: pointer;"></i></a>
		<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
		<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
		<div style="margin:0 auto; text-align: center;">
			<div class="matTitulo">
				<i class="fal fa-file-search" id="ico"></i>
				<h1 class="titulo" style="display:inline-block;">GRAFICA DEL HISTORIAL DE MEDICIONES</h1>
			</div>
			<mat-divider class="mt-3"></mat-divider>
		</div>
	</div>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="graphic-style">
						<ngx-charts-line-chart [legend]="legend" [legendTitle]="legendTitle" [scheme]="colorScheme"
							[showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxis]="xAxis"
							[yAxis]="yAxis" [autoScale]="autoScale" [results]="dataGrafica" [timeline]="timeline"
							[xAxisTickFormatting]="tickFormatting">
						</ngx-charts-line-chart>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
